import React, { useState } from "react";
import DataTable from "../../components/DataTable";
import PageWrapperForm from "../../components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { UserRechargeCommission } from "../../config/tableConfigs";

import DeleteModal from "../../components/DeleteModal";
import { useSession } from "hooks/useSession";
import { useTableData } from "hooks/useTableData";

const UserCommissionManager = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const { userid } = useSession(); // 🔄 trigger refresh

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };



  const tableData = useTableData(
    `https://pro.mokshiq.in/retailer_commission?id=${userid}`,
    UserRechargeCommission,
    // 👈 hook re-fetches when refresh changes
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deletescheme1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      console.log("Deleting selected records:", selectedIds);
      // call delete API → then refresh
      setRefresh((prev) => prev + 1);
    }
  };

  // ✅ Handle successful form submission
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={UserRechargeCommission}
        handleOnclick={handleAddUser}
        buttonTitle={""}
      >
        <DataTable
          config={UserRechargeCommission}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>



      <DeleteModal
        deleteid={selectedUser?.id}
        id="deletescheme1"
        title="Delete Scheme"
        message="Are you sure you want to delete this scheme?"
        apiUrl="https://pro.mokshiq.in/scheme_manager_action"
        onSuccess={handleDeleteSuccess} // ✅ Pass success callback
      />
    </div>
  );
};

export default UserCommissionManager;